import { memoize, get } from 'lodash';
import { createSelector } from 'reselect';
const selectorFactory = (dataSelector) => memoize((path) => createSelector(dataSelector, (data) => get(data, path)));
const getSelectorDefinition = {
    id: 'get',
    selectorFactory,
    dependencies: [
        { selector: 'data' },
    ],
};
export default getSelectorDefinition;
